<template>
  <div class="container">
    <container :active_path="path">
      <div class="base-warp">
        <div class="head">
          <el-form :model="search"
                   ref="form"
                   label-width="80px"
                   :inline="true"
                   size="normal">
            <el-form-item label="项目">
              <el-autocomplete v-model="search.project"
                               value-key="name"
                               placeholder="输入项目名称"
                               clearable
                               size="mini"
                               :fetch-suggestions="querySearchAsync"
                               @select="handleSelect">
              </el-autocomplete>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="search.status"
                         placeholder="状态"
                         size="mini">
                <el-option :label="item.label"
                           :value="item.value"
                           v-for="(item, index) in status"
                           :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="户型名">
              <el-input size="mini"
                        v-model="search.keyword"
                        placeholder="搜索户型名"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="mini"
                         type="primary"
                         @click="confirm">搜索</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-box">
          <el-table :data="tabledata"
                    border
                    stripe
                    @row-click="getrow"
                    size="small"
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
            <el-table-column label="序号"
                             type="index"
                             width="60"></el-table-column>
            <el-table-column label="户型名"
                             prop="name"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="用户"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                {{scope.row.user.name}}/{{scope.row.user.telephone}}
              </template>
            </el-table-column>
            <el-table-column label="单价">
              <template slot-scope="scope">
                {{scope.row.price?scope.row.price+'元/㎡/月':''}}
              </template>
            </el-table-column>
            <el-table-column label="总价">
              <template slot-scope="scope">
                {{scope.row.total_price?scope.row.total_price+'元/月':''}}
              </template>
            </el-table-column>
            <el-table-column label="房租">
              <template slot-scope="scope">
                押{{scope.row.deposit}}付{{scope.row.payMonth}}
              </template>
            </el-table-column>
            <el-table-column label="适合经营">
              <template slot-scope="scope">
                {{scope.row.message?scope.row.message.manage:''}}
              </template>
            </el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <p class="status text-warning"
                   v-if="scope.row.status=='02'">待审核</p>
                <p class="status text-success"
                   v-if="scope.row.status=='03'">已通过</p>
                <p class="status text-danger"
                   v-if="scope.row.status=='04'">不通过</p>
              </template>
            </el-table-column>

          </el-table>
        </div>
        <el-pagination class="page-tion"
                       @current-change="currentChange"
                       layout="prev, pager, next"
                       :page-size="pagesize"
                       :total="total"
                       background>
        </el-pagination>
      </div>
    </container>
    <router-view></router-view>
  </div>
</template>

<script>
import container from "../../../components/container"
export default {
  components: {
    container,
  },
  data () {
    return {
      path: '/attract/house',
      search: {
        keyword: '',
        project: '',
        status: '',
        houseId: '',
      },
      status: [
        {
          label: '全部',
        },
        {
          label: '待审核',
          value: '02',
        },
        {
          label: '已通过',
          value: '03',
        },
        {
          label: '不通过',
          value: '04',
        },
      ],
      timeout: '',
      restaurants: [],
      loading: '',
      tabledata: [],
      total: 0,
      pageNo: 1,
      pagesize: 14,
    }
  },
  mounted () {
    this.getTableData();
  },
  methods: {
    getTableData () {
      var params = {
        pageNo: this.pageNo,
        pagesize: this.pagesize,
        status: this.search.status,
        keyword: this.search.keyword,
        houseId: this.search.project ? this.search.houseId : '',
      }
      this.$api.getTypeList(params).then(
        data => {
          let { list, total } = data;
          for (var item of list) {
            if (item.message) item.message = JSON.parse(item.message)
          }
          this.total = total;
          this.tabledata = list;
        }
      )
    },
    getrow (row) {
      var id = row._id['$oid'];
      this.$router.push({ path: '/attract/house/detail', query: { id } });
    },
    currentChange (page) {
      this.pageNo = page;
      this.getTableData();
    },
    confirm () {
      this.pageNo = 1;
      this.getTableData();
    },
    querySearchAsync (queryString, cb) {
      if (this.loading) return;
      var params = {
        pageNo: 1,
        pagesize: 10,
        region: '',
        price: '',
        keyword: queryString,
        type: '',
        status: '',
      }
      this.loading = true;
      this.$api.getproject(params).then(
        data => {
          this.loading = false;
          let { list } = data;
          cb(list);
        }
      )
    },
    handleSelect (item) {
      this.search.houseId = item._id['$oid'];
    }
  },
  beforeRouteUpdate (to, from, next) {
    if (from.path == "/attract/house/detail") {
      this.getTableData();
    }
    next();
  },
}
</script>

<style lang="scss" scoped>
</style>